import React from 'react';
import './Optimizedfeatu.css';

const Optimizedfeatu = () => {
    return (
        <div className="Optimize-container">
            <h2 className="Optimize-heading">FEATURES</h2>

            <div className="Optimize-card">


                <ul className="Optimize-list" data-aos="fade-down">
                    <li><strong>Optimized Clamping System  –</strong> with high rigidity and high precision.</li>
                    <li><strong>Short Response Time –</strong> Modular oil circuit design.</li>
                    <li><strong>Automatic V-P Switch  –</strong> High response and double cylinder injection system.</li>
                    <li><strong>High Speed & Precise Microcomputer Controller –</strong>  With large screen display.</li>
                    <li><strong>Suit For More Molds –</strong> Multi functional ejection for selection and inclusion of core pulling interface suitable for different kinds of mold.</li>
                    <li><strong>More Accurate Measurement –</strong>Professional design of feeding system.</li>
                </ul>
            </div>
        </div>
    );
};

export default Optimizedfeatu;
